export default __webpack_public_path__ + "static/aboutus1-b2980739faad5be6343f9def00530063.png";